import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=3b9fe1e0&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9fe1e0')) {
      api.createRecord('3b9fe1e0', component.options)
    } else {
      api.reload('3b9fe1e0', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=3b9fe1e0&", function () {
      api.rerender('3b9fe1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2T3DdXxwUY9I7/JS/offershelp.vue"
export default component.exports